import DiagnosticAssessment from './template';

export default DiagnosticAssessment;
